// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wEt4N","danger":"Button_danger__PCfrT","empty":"Button_empty__yeCjg"};